import type { DrawNumber } from '../draw/entry.js';
import type { Product } from '../product/entry.js';
import type { EventNumber } from './EventNumber.js';

/**
 * Fallback event ID used when sportinfo is missing for a draw event.
 * Uses the format `${product}_${drawNumber}_${eventNumber}` to avoid collisions
 * across products with overlapping draw numbers.
 * Only exists on MINIMAL event objects — never on COMPLETE ones.
 */
export type FallbackEventId = `${Product}_${DrawNumber}_${EventNumber}`;

/**
 * Constructs a FallbackEventId from the draw context and event number.
 *
 * @param product Product identifier
 * @param drawNumber Draw number for current draw
 * @param eventNumber Event number within the draw
 * @returns FallbackEventId string
 */
export function getFallbackEventId(
  product: Product,
  drawNumber: DrawNumber,
  eventNumber: EventNumber
): FallbackEventId {
  return `${product}_${drawNumber}_${eventNumber}`;
}
